import React, { useState, useEffect, useContext } from 'react';
import { OCULTAR_GESTION_VACACIONES_FICHA } from '../../../config/flags';
import Form from 'react-bootstrap/Form';
import bcrypt from 'bcryptjs';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Button from 'react-bootstrap/Button';
import { Trash2, IdCard, Building2, Wrench, Umbrella, MapPin, Phone, Calendar, Users, Briefcase, Server, Monitor, Send, Lock, Laptop, Info } from 'lucide-react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import ImagenDefault from './../../img/imgDefault.png';
import IconosGenerales from "../iconos/IconosGenerales";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchCrearPersona, fetchPersonasData, fetchAdjuntosData, fetchTiposContrato } from '../../../peticiones_API/PeticionesGestionPersonasPersonas';
import { fetchCrearPersonaColaboradora } from '../../../peticiones_API/PeticionesPersonasColaboradoras';
import { fetchOficinasData } from '../../../peticiones_API/PeticionesGestionPersonasOficinas';
import { fetchCalendariosLaborales } from '../../../peticiones_API/PeticionesCalendariosLaborales';
import { fetchCalendariosLaboralesColab } from '../../../peticiones_API/PeticionesCalendariosLaboralesColab';
import { fetchEmpresasColaboradorasData } from '../../../peticiones_API/PeticionesEmpresasColaboradoras';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import ErrorForm from '../eventos/avisos/Alerta';
import { handleChangeErrors, handleSubmitErrorsPersonas, todosDatosCorrectos } from '../../validacion/ValidationFormPersona';
import { DatosCorrectosPersona, ServerNoCreoPersona, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import { ToastContainer, toast } from "react-toastify";
import { UsuarioContext } from "../../providers/personaContext";
import { getProvincias, getMunicipios, buscarDireccionPorCP, buscarCPPorPoblacion, buscarProvinciaPorNombre } from '../../../utils/direccionesUtils';
import useFormPersistence from '../../../hooks/useFormPersistence';


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ pt: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
}


/* Sin `estados`: el estado dejo de elegirse y ahora se deriva de las fechas en el servidor.
 * El prop sigue existiendo para `FormEditarPersona`, donde la ficha SI puede cambiarlo. */
const FormCrearPersona = ({ departamentos, roles, negocios, empresasContratantes, tipo = "empleado" }) => {

const persona = useContext(UsuarioContext);
const location = useLocation();
const navigate = useNavigate();

const initialFormState = {
        nombre: '',
        apellidos: '',
        foto: '',
        direccion: '',
        telefono_empresa: '',
        telefono_fijo: '',
        extension_telefono: '',
        provincia: '',
        poblacion: '',
        dni: '',
        dni_fecha_caducidad: '',
        fecha_nacimiento: '',
        Oficinas: [],
        mail_empresa: '',
        fecha_baja: '',
        correo_personal: '',
        telefono_personal: '',
        empresa_contratante_id: null,
        tipo_contrato: null,
        fecha_alta: '',
        observaciones_soporte: '',
        direccion_envio: 'personal',
        calendario_laboral_id: '',
        calendario_laboral_colab_id: '',
        supervisor_ids: [],
        dias_vacaciones_totales: 22,
        dias_verano_obligatorios: 10,
        observaciones_vacaciones: '',
        gestion_vacaciones_int: null,
        gestion_vacaciones_colab: null,
    };

const [formData, setFormData, clearFormDraft, wasRestored] = useFormPersistence(
    'crear_persona',
    initialFormState
);

    const [oficinas, setOficinas] = useState([]);
    const [calendariosLaborales, setCalendariosLaborales] = useState([]);
    const [calendariosLaboralesColab, setCalendariosLaboralesColab] = useState([]);
    const [supervisores, setSupervisores] = useState([]);
    const [filasInternos, setFilasInternos] = useState([]);
    const [filasOrganigrama, setFilasOrganigrama] = useState([]);
    const [erroresCargos, setErroresCargos] = useState({ internos: [], organigrama: [] });
    const [adjuntosPorCargo, setAdjuntosPorCargo] = useState([]);
    const [empresasColaboradoras, setEmpresasColaboradoras] = useState([]);
    // Los tipos de contrato vienen del servidor, no de una lista aqui.
    const [tiposContrato, setTiposContrato] = useState([]);
    useEffect(() => {
        fetchTiposContrato().then(setTiposContrato).catch(() => setTiposContrato([]));
    }, []);

    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
        apellidos: "Debes insertar mínimo un apellido",
        ...(tipo !== "colaboradora" && { dni: "Debes insertar un DNI" }),
        mail_empresa: "Debes insertar un mail de empresa válido",
        observaciones_soporte: "Debes insertar una observación en el apartado de soporte para guardar los datos sensibles",
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: null,
        apellidos: null,
        apellidos: null,
        ...(tipo !== "colaboradora" && { dni: null }),
        mail_empresa: null,
    });

    const [formCompletado, setFormCompletado] = useState(null);
    /* ── A DONDE VOLVER DESPUES DE CREAR ────────────────────────────────────────────────────
     * El dialogo de exito redirige a `/gestionpersonas/personas` + lo que le pasemos, y hasta hoy
     * le pasabamos `location.search` — que al CREAR esta vacio. Resultado: una colaboradora se
     * creaba bien y volvias a la pestana de INTERNOS; y como el listado filtra por «Alta» por
     * defecto, si ademas nacia «En Proceso» tampoco salia en la suya. Dos capas, y entre las dos
     * ocho colaboradores creados que parecian no haberse guardado.
     * Se construye con lo que DICE EL SERVIDOR, no con lo que creemos haber mandado. */
    const [destinoListado, setDestinoListado] = useState('');
    const [estadosActualizados, setEstadosActualizados] = useState(false);
    const [provinciaId, setProvinciaId] = useState(null);
    const [municipios, setMunicipios] = useState([]);
    const [avisado, setAvisado] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const [errorEnviarForm, setErrorEnviarForm] = useState({
        personaDuplicada: null,
        refDuplicado: null
    });

    const provincias = getProvincias();

    const handleTabChange = (event, newValue) => {
        if (newValue === 3) {
            setEstadoCampoReque(prev => ({
                ...prev,
                observaciones_soporte: null
            }));
        }else{
            setEstadoCampoReque({
                nombre: null,
                apellidos: null,
                ...(tipo !== "colaboradora" && { dni: null }),
                mail_empresa: null,
            });  
        }

        setTabValue(newValue);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(tabValue === 3) {
            if(formData.bit_locker && formData.bit_locker.length !== 55){
                toast.error('El número de serie del BitLocker debe tener el formato correcto (000000-000000-000000-000000-000000-000000-000000-000000) con 48 dígitos en total.');
                return;
            }
        }


        setAvisado(false);
        setEstadosActualizados(false);

        if (tipo === "empleado") {
            const erroresInternosIdx = [];
            const erroresOrganigramaIdx = [];

            filasInternos.forEach((fila, index) => {
                if (!fila.empresa) return;
                if (!fila.departamento || !fila.cargo) {
                    erroresInternosIdx.push(index);
                }
            });

            filasOrganigrama.forEach((fila, index) => {
                if (!fila.empresa) return;
                if (!fila.departamento || !fila.cargo) {
                    erroresOrganigramaIdx.push(index);
                }
            });

            if (erroresInternosIdx.length > 0 || erroresOrganigramaIdx.length > 0) {
                setErroresCargos({ internos: erroresInternosIdx, organigrama: erroresOrganigramaIdx });
                toast.error('Por favor, complete los campos obligatorios de los cargos. Se requiere departamento y cargo.');
                return;
            }

            setErroresCargos({ internos: [], organigrama: [] });
        }

        handleSubmitErrorsPersonas(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
    };

    useEffect(() => {
        const nuevosMunicipios = getMunicipios(provinciaId);
        setMunicipios(nuevosMunicipios);
    }, [provinciaId]);

    useEffect(() => {
        const cargarOficinas = async () => {
            try {
                const data = await fetchOficinasData();
                const oficinasOrdenadas = data.sort((a, b) => a.nombre.localeCompare(b.nombre));
                setOficinas(oficinasOrdenadas);
            } catch (error) {
                console.error('Error al cargar oficinas:', error);
            }
        };
        cargarOficinas();
    }, []);

    useEffect(() => {
        const cargarCalendariosLaborales = async () => {
            try {
                if (tipo === "colaboradora") {
                    const data = await fetchCalendariosLaboralesColab();
                    setCalendariosLaboralesColab(data || []);
                } else {
                    const data = await fetchCalendariosLaborales();
                    setCalendariosLaborales(data || []);
                }
            } catch (error) {
                console.error('Error al cargar calendarios laborales:', error);
            }
        };
        cargarCalendariosLaborales();
    }, [tipo]);

    useEffect(() => {
        const cargarSupervisores = async () => {
            try {
                const data = await fetchPersonasData();
                const personasOrdenadas = (data || []).sort((a, b) =>
                    `${a.nombre} ${a.apellidos}`.localeCompare(`${b.nombre} ${b.apellidos}`)
                );
                setSupervisores(personasOrdenadas);
            } catch (error) {
                console.error('Error al cargar supervisores:', error);
            }
        };
        cargarSupervisores();
    }, []);

    useEffect(() => {
        const cargarEmpresasColaboradoras = async () => {
            try {
                const data = await fetchEmpresasColaboradorasData();
                setEmpresasColaboradoras(data || []);
            } catch (error) {
                console.error('Error al cargar empresas colaboradoras:', error);
            }
        };
        cargarEmpresasColaboradoras();
    }, [tipo]);

    useEffect(() => {
        const imgInput = document.getElementById("imagenPersona_img");
        const valorImg = imgInput ? imgInput.value : "";
        const f = new Date();
        const dia = ('0' + f.getDate()).slice(-2);
        const mes = ('0' + (f.getMonth() + 1)).slice(-2);
        const año = f.getFullYear();
        const hora = ('0' + f.getHours()).slice(-2);
        const minutos = ('0' + f.getMinutes()).slice(-2);
        const segundos = ('0' + f.getSeconds()).slice(-2);

        if ((formData.foto == "" || formData.foto == null) && valorImg != "") {
            const foto = `${dia}${mes}${año}${hora}${minutos}${segundos}_persona_img`;
            setFormData(prevFormData => ({ ...prevFormData, foto }));
        }

        if (estadosActualizados) {
            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            if (validacionTodosDatos.todosCamposFalse()) {
                /* `setFormCompletado(true)` ya NO va aqui: va DESPUES del await. Puesto antes, el
                 * dialogo «Espere mientras se envian sus datos» se abria y redirigia a los 2
                 * segundos **aunque el servidor rechazara**, y ademas capturaba el destino en ese
                 * momento —cuando todavia no se sabe en que estado ha quedado la persona—. */
                setErrorEnviarForm({ personaDuplicada: false, refDuplicado: null });
                /* ── FUNCION ASINCRONA PROPIA, PORQUE UN `useEffect` NO PUEDE SER `async` ────────
                 * El envio necesita `await` —ver abajo— y el callback de un efecto no admite serlo:
                 * devolver una promesa ahi la toma React como funcion de limpieza. Asi que el
                 * trabajo va dentro de su propia funcion y el efecto la llama. */
                (async () => {
                try {
                    const dataToSend = { ...formData };

                    if (dataToSend.fecha_nacimiento == '') dataToSend.fecha_nacimiento = null;
                    if (dataToSend.fecha_alta == '') dataToSend.fecha_alta = null;
                    if (dataToSend.fecha_baja == '') dataToSend.fecha_baja = null;
                    if (dataToSend.dni_fecha_caducidad == '') dataToSend.dni_fecha_caducidad = null;

                    if (formData.Oficinas && Array.isArray(formData.Oficinas)) {
                        dataToSend.Oficinas = formData.Oficinas.map(oficina => oficina.Id);
                    } else {
                        dataToSend.Oficinas = [];
                    }

                    const esColab = tipo === "colaboradora";
                    const cargosFormateados = [
                        ...filasInternos
                            .filter(fila => fila.empresa)
                            .map(fila => ({
                                empresa_id: esColab ? null : fila.empresa,
                                empresa_colaboradores_id: esColab ? fila.empresa : null,
                                departamento_id: esColab ? null : fila.departamento,
                                cargo: esColab ? null : fila.cargo
                            })),
                        ...filasOrganigrama
                            .filter(fila => fila.empresa)
                            .map(fila => ({
                                empresa_id: esColab ? null : fila.empresa,
                                empresa_colaboradores_id: esColab ? fila.empresa : null,
                                departamento_id: esColab ? null : fila.departamento,
                                cargo: esColab ? null : fila.cargo,
                                responsable: fila.responsable,
                                adjunto: fila.adjunto
                            }))
                    ];
                    dataToSend.Cargos = cargosFormateados;
                    if (esColab) {
                        dataToSend.empresa_colaboradora_id = filasInternos.find(f => f.empresa)?.empresa ? parseInt(filasInternos.find(f => f.empresa).empresa) : null;
                    }

                    /* ── EL `await` QUE FALTABA, Y NO ERA COSMETICO ──────────────────────────
                     *
                     * Sin el, el rechazo del servidor salia FUERA del `try`: el `catch` de abajo no
                     * veia NADA, `personaDuplicada` no se ponia nunca, y la consola decia «Persona
                     * creada» enseñando una Promesa. **La peticion salia, el servidor la rechazaba,
                     * y no habia un solo sitio que lo dijera.**
                     *
                     * Y afecta a LOS DOS CAMINOS: el ternario es el mismo para interno y para
                     * colaboradora, asi que crear un interno fallaba igual de mudo. Nadie lo habia
                     * notado porque normalmente funciona — un fallo silencioso solo se ve el dia
                     * que algo falla. */
                    const response = await (tipo === "colaboradora"
                        ? fetchCrearPersonaColaboradora(dataToSend)
                        : fetchCrearPersona(dataToSend));
                    console.log("Persona creada:", response);

                    /* Y EL BORRADOR SE LIMPIA SOLO SI EL SERVIDOR ACEPTO. Antes se ejecutaba pase lo
                     * que pase, asi que un rechazo te borraba lo escrito. De los dos efectos de no
                     * esperar, ese era el peor: no solo no te decia que habia fallado — encima te
                     * quitaba lo que ibas a tener que volver a teclear. */
                    clearFormDraft();

                    /* ── EL DESTINO, CON EL ESTADO QUE PUSO EL SERVIDOR ──────────────────────
                     * `tabPersonas` para caer en la pestana correcta, y `estado` para que el
                     * filtro del listado incluya a quien se acaba de crear.
                     *
                     * No EXPLICA el filtro —quien no sepa que existe sigue sin saberlo— pero evita
                     * el tropiezo, que es el intercambio que interesa: no hay que entender nada
                     * para que la persona aparezca.
                     *
                     * Y solo actua cuando hace falta: alguien creado con fecha pasada nace en
                     * «Alta», que ya es el valor por defecto, asi que no se nota. El filtro solo se
                     * mueve cuando la persona NO habria salido.
                     *
                     * Los dos parametros sobreviven a paginar y a buscar — comprobado contra
                     * `gestionURL` despues de quitarle la lista blanca. */
                    const creada = response && response.data;
                    const qs = new URLSearchParams();
                    if (tipo === "colaboradora") qs.set('tabPersonas', '1');
                    if (creada && creada.estado != null) qs.set('estado', String(creada.estado));
                    setDestinoListado(qs.toString() ? `?${qs.toString()}` : '');

                    setFormCompletado(true);
                } catch (error) {
                    const d = error?.response?.data;
                    if (d?.error === 'REGISTRO_DUPLICADO') {
                        setErrorEnviarForm({ personaDuplicada: true });
                    } else {
                        /* CUALQUIER OTRO ERROR SE DICE. `handleAuthError` solo actua en 401 —cierra
                         * sesion— y en 403 —avisa—; un 400 o un 409 llegaban hasta aqui y morian en
                         * silencio. Se enseña el mensaje DEL SERVIDOR, que es el que sabe por que:
                         * «En proceso lo pone el alta», «ese tipo de contrato no es valido», «la
                         * fecha de baja no puede ser anterior a la de alta»… */
                        toast.error(d?.message || 'No se ha podido guardar. Vuelve a intentarlo.');
                    }
                    setFormCompletado(false);
                } finally {
                    setEstadosActualizados(false);
                }
                })();
            } else if (!avisado) {
                toast.error("Faltan campos por rellenar");
                setAvisado(true);
            }
        }
    }, [estadosActualizados, formData, estadoCampoReque]);

    const [previsualizacionImg, setPrevisualizacionImg] = useState(null);

    const handleChange = (event, value, name) => {

         setFormCompletado(null); // Cuando se hacen cambios los datos no están listos.

        if (name === 'Oficinas') {
            setFormData(prevFormData => {
                const nuevasOficinas = value;
                let nuevaDireccionEnvio = prevFormData.direccion_envio;

                // Si la dirección de envío era de una oficina que ya no está, resetear a personal
                if (prevFormData.direccion_envio?.startsWith('oficina-')) {
                    const oficinaIdActual = parseInt(prevFormData.direccion_envio.split('-')[1]);
                    const oficinaExiste = nuevasOficinas.some(o => o.Id === oficinaIdActual);
                    if (!oficinaExiste) {
                        nuevaDireccionEnvio = 'personal';
                    }
                }

                return {
                    ...prevFormData,
                    Oficinas: nuevasOficinas,
                    direccion_envio: nuevaDireccionEnvio
                };
            });
            return;
        }

        const { name: inputName, value: inputValue, type, files } = event.target;
        const fieldName = name || inputName;
        let newValue;

        if (type === 'file') {
            newValue = files[0];
        } else if ((fieldName === 'telefono_empresa' || fieldName === 'telefono_fijo' || fieldName === 'extension_telefono') && !/^\d*$/.test(inputValue)) {
            newValue = inputValue !== '' ? parseInt(inputValue) : null;
        // Sin rama para `Rol`: ese campo ya no existe en este formulario.
        } 
        else if( event?.target?.name === 'ruskdesk_pc' || event?.target?.name === 'ruskdesk_movil' || event?.target?.name === 'conexion_remota_movil' || event?.target?.name === 'conexion_remota' && !/^\d*$/.test(inputValue)) {
                newValue = inputValue !== '' ? parseInt(inputValue) : null;
        }
        else if (event?.target?.name === 'bit_locker') {
            // Eliminar todo lo que NO sea número
            const s = inputValue.replace(/\D/g, '');

            // Cada 6 números coloca un - y limita a 48 caracteres (8 grupos de 6 números)
            if (s.length > 0) {
                const resultado = s.match(/.{1,6}/g)?.join('-');
                console.log(resultado);
                newValue = resultado;
            }
        }   
        else {
            newValue = inputValue;
        }
                                  
        if (event?.target?.name === 'nombre' || event?.target?.name === 'apellidos' || event?.target?.name === 'dni') {

            const valorNombre = fieldName === 'nombre' ? newValue : formData.nombre;
            const valorApellidos = fieldName === 'apellidos' ? newValue : formData.apellidos;
            const valorDni = fieldName === 'dni' ? newValue : formData.dni;
            const passwordGenerado = `${valorNombre ? valorNombre.trim()[0].toUpperCase() : ''}${valorApellidos ? valorApellidos.trim()[0].toUpperCase() : ''}${valorDni ? valorDni.trim().toUpperCase() : ''}`;

            setFormData(prev => ({
                ...prev,
                password_usuario_equipo: passwordGenerado
            }));
        }  
        
        // Update logic for address fields
        if (fieldName === 'codigo_postal' && inputValue.length === 5) {
            const address = buscarDireccionPorCP(inputValue);
            if (address) {
                setFormData(prev => ({
                    ...prev,
                    ...address,
                    codigo_postal: inputValue
                }));
                setProvinciaId(address.provinciaId);
            } else {
                setFormData(prev => ({ ...prev, [fieldName]: newValue }));
            }
        } else if (fieldName === 'provincia') {
            const provId = buscarProvinciaPorNombre(inputValue);
            setProvinciaId(provId);
            setFormData(prev => ({ ...prev, provincia: inputValue, poblacion: '', codigo_postal: '' }));
        } else if (fieldName === 'poblacion' && inputValue && formData.provincia) {
            const cp = buscarCPPorPoblacion(formData.provincia, inputValue);
            if (cp) {
                setFormData(prev => ({ ...prev, poblacion: inputValue, codigo_postal: cp }));
            } else {
                setFormData(prev => ({ ...prev, [fieldName]: newValue }));
            }
        } else {
            setFormData(prevFormData => ({ ...prevFormData, [fieldName]: newValue }));
        }
        

        if (type === 'file' && files[0]) {
            const file = files[0];
            const reader = new FileReader();

            if (fieldName === 'imagenPersona_img') {
                reader.onloadend = () => setPrevisualizacionImg(reader.result);
                reader.readAsDataURL(file);
            }
        }

        if (fieldName in estadoCampoReque) {
            handleChangeErrors(fieldName, inputValue, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }
    };

    const agregarFilaInterno = () => {
        setFilasInternos([...filasInternos, { empresa: '', departamento: '', cargo: '' }]);
    };

    const agregarFilaOrganigrama = () => {
        setFilasOrganigrama([...filasOrganigrama, { empresa: '', departamento: '', cargo: '', responsable: '', adjunto: '' }]);
    };

    const handleChangeFilaInterno = (index, campo, valor) => {
        const nuevasFilas = [...filasInternos];
        nuevasFilas[index][campo] = valor;

        if (campo === 'empresa') {
            const empresaId = valor;

            if (tipo !== "colaboradora") {
                const departamentosEmpresa = departamentos.filter(departamento =>
                    departamento.tipo === 'interno' &&
                    departamento.Negocios && departamento.Negocios.some(empresa =>
                        empresa.Id.toString() === empresaId
                    )
                );

                const departamentoActual = nuevasFilas[index].departamento;
                const esDepartamentoValido = departamentosEmpresa.some(dept =>
                    dept.Id.toString() === departamentoActual
                );

                if (!esDepartamentoValido) {
                    nuevasFilas[index].departamento = '';
                    nuevasFilas[index].cargo = '';
                }
            }
        }

        setFilasInternos(nuevasFilas);
        setErroresCargos(prev => ({ ...prev, internos: prev.internos.filter(i => i !== index) }));
    };

    const handleChangeFilaOrganigrama = (index, campo, valor) => {
        const nuevasFilas = [...filasOrganigrama];

        if (campo === 'responsable' && valor) {
            nuevasFilas[index]['responsable'] = true;
            nuevasFilas[index]['adjunto'] = '';
        } else if (campo === 'adjunto' && valor) {
            nuevasFilas[index]['adjunto'] = valor;
            nuevasFilas[index]['responsable'] = false;
        } else {
            nuevasFilas[index][campo] = valor;
        }

        if (campo === 'empresa') {
            const empresaId = valor;

            if (tipo !== "colaboradora") {
                const departamentosEmpresa = departamentos.filter(departamento =>
                    departamento.tipo === 'organigrama' &&
                    departamento.Negocios && departamento.Negocios.some(empresa =>
                        empresa.Id.toString() === empresaId
                    )
                );

                const departamentoActual = nuevasFilas[index].departamento;
                const esDepartamentoValido = departamentosEmpresa.some(dept =>
                    dept.Id.toString() === departamentoActual
                );

                if (!esDepartamentoValido) {
                    nuevasFilas[index].departamento = '';
                    nuevasFilas[index].cargo = '';
                    nuevasFilas[index].adjunto = '';
                    setAdjuntosPorCargo(prev => {
                        const copia = [...prev];
                        copia[index] = [];
                        return copia;
                    });
                }
            }
        }

        if (campo === 'departamento') {
            async function actualizarAdjuntos() {
                let adjuntosData = [];
                if (nuevasFilas[index].empresa && nuevasFilas[index].departamento) {
                    adjuntosData = await fetchAdjuntosData(nuevasFilas[index].empresa, nuevasFilas[index].departamento);
                }
                setAdjuntosPorCargo(prev => {
                    const copia = [...prev];
                    copia[index] = adjuntosData;
                    return copia;
                });
                nuevasFilas[index].adjunto = '';
            }
            actualizarAdjuntos();
        }

        setFilasOrganigrama(nuevasFilas);
        setErroresCargos(prev => ({ ...prev, organigrama: prev.organigrama.filter(i => i !== index) }));
    };

    const eliminarFilaInterno = (index) => {
        setFilasInternos(filasInternos.filter((_, i) => i !== index));
    };

    const eliminarFilaOrganigrama = (index) => {
        setFilasOrganigrama(filasOrganigrama.filter((_, i) => i !== index));
    };

    const esMandoIntermedio = (departamentoId, empresaId) => {
        if (!departamentoId || !empresaId) return false;
        const dept = departamentos.find(d => d.Id.toString() === departamentoId.toString());
        if (!dept || !dept.Negocios) return false;
        const emp = dept.Negocios.find(e => e.Id.toString() === empresaId.toString());
        return emp && emp.DepartamentoEmpresa && emp.DepartamentoEmpresa.mando_intermedio_de_1 != null;
    };

    const getDepartamentosPorEmpresaYTipo = (empresaId, filaIndex, tipoDepto, filasTipo) => {
        if (!empresaId) return [];

        const departamentosEmpresa = departamentos.filter(departamento =>
            departamento.tipo === tipoDepto &&
            departamento.Negocios && departamento.Negocios.some(empresa =>
                empresa.Id.toString() === empresaId
            )
        );

        const departamentosSeleccionados = filasTipo
            .filter((fila, idx) => idx !== filaIndex && fila.empresa === empresaId && fila.departamento)
            .map(fila => fila.departamento);

        return departamentosEmpresa
            .filter(departamento =>
                !departamentosSeleccionados.includes(departamento.Id.toString())
            )
            .sort((a, b) => a.nombre.localeCompare(b.nombre));
    };

    const handleDelete = () => {
        setPrevisualizacionImg(null);
        const imgInput = document.getElementById("imagenPersona_img");
        if (imgInput) imgInput.value = "";
        setFormData(prevData => ({ ...prevData, foto: null }));
    };

    return ( 
        <>
            <Form>
                <CabeceraForm>
                    <Titulo texto={tipo === "colaboradora" ? "AGREGA UN COLABORADOR" : "AGREGA UN EMPLEADO"} />
                </CabeceraForm>

                <Container>
                    <ToastContainer/>
                    <Col>
                        {/* Tabs de navegación */}
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={tabValue} onChange={handleTabChange} aria-label="Pestañas de formulario" left>
                                <Tab 
                                    label="PERSONAL" 
                                    icon={<IdCard size={20} />} 
                                />
                                <Tab 
                                    label= {tipo === "colaboradora" ? "EMPRESA" : "NEGOCIO"}
                                    icon={<Building2 size={20} />} 
                                />
                                <Tab
                                    label="VACACIONES"
                                    icon={<Umbrella size={20} />}
                                />
                                {persona.persona?.rol?.toLowerCase() === 'super administrador' && (
                                    <Tab
                                        label="SOPORTE"
                                        icon={<Wrench size={20} />}
                                    />
                                )}
                            </Tabs>
                        </Box>

                        {/* Contenido de la pestaña Datos Personales */}
                        <TabPanel value={tabValue} index={0}>
                            {/* ── QUÉ SE ESTÁ SALTANDO ────────────────────────────────────────
                                Este es el camino CORTO, y se queda: hay casos que no pasan por
                                Incorporaciones —alguien que lleva años, una corrección, alguien
                                que vuelve—, y pedir una fecha de incorporación a quien entró hace
                                cinco años generaría tareas de un onboarding que nadie va a hacer.

                                Pero conviene que quien lo use sepa qué NO va a ocurrir. El aviso
                                va aquí y no en el botón: un texto largo en una barra de acciones
                                no se lee, y aquí hay sitio para decirlo entero. */}
                            <Alert severity="info" icon={<Info size={20} />} sx={{ mb: 2 }}>
                                <strong>Esto crea la persona, no su incorporación.</strong>{' '}
                                No se genera proceso de alta, no hay tareas ni recursos que
                                preparar, no se avisa a nadie, y no aparecerá en el embudo de
                                Incorporaciones.{' '}
                                Para una incorporación de verdad, úsalo desde el módulo.
                            </Alert>

                            {/* Header con Foto y Datos Básicos */}
                            <SeccionCard>
                                <PerfilHeader>
                                    <ImagenPerfilContainer>
                                        {previsualizacionImg ? (
                                            <ContenedorEncabezado>
                                                <IconosGenerales
                                                    alerta="true"
                                                    id="delete"
                                                    onClick={handleDelete}
                                                />
                                                <img
                                                    src={previsualizacionImg}
                                                    alt="Vista previa"
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0
                                                    }}
                                                />
                                            </ContenedorEncabezado>
                                        ) : (
                                            <ImagenPerfil src={ImagenDefault} alt="Sin foto" />
                                        )}
                                    </ImagenPerfilContainer>

                                    <DatosBasicosContainer>
                                        <Form.Group>
                                            <TituloCategoria>Nombre <span>*</span></TituloCategoria>
                                            <Form.Control type='text' name='nombre' value={formData.nombre || ''} onChange={handleChange} />
                                            <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                                        </Form.Group>

                                        <Form.Group>
                                            <TituloCategoria>Apellidos <span>*</span></TituloCategoria>
                                            <Form.Control type='text' name='apellidos' value={formData.apellidos || ''} onChange={handleChange} />
                                            <ErrorForm mensaje={camposRequeridos.apellidos} estadoAlerta={estadoCampoReque.apellidos} />
                                        </Form.Group>

                                        <Form.Group>
                                            <TituloCategoria>DNI {tipo !== "colaboradora" && <span>*</span>}</TituloCategoria>
                                            <Form.Control type='text' name='dni' value={formData.dni || ''} onChange={handleChange} />
                                            {tipo !== "colaboradora" && <ErrorForm mensaje={camposRequeridos.dni} estadoAlerta={estadoCampoReque.dni} />}
                                        </Form.Group>

                                        <Form.Group>
                                            <TituloCategoria>Caducidad DNI</TituloCategoria>
                                            <Form.Control type='date' name='dni_fecha_caducidad' value={formData.dni_fecha_caducidad || ''} onChange={handleChange} />
                                        </Form.Group>

                                        <Form.Group>
                                            <TituloCategoria>Fecha de Nacimiento</TituloCategoria>
                                            <Form.Control type="date" name="fecha_nacimiento" value={formData.fecha_nacimiento || ''} onChange={handleChange} />
                                        </Form.Group>

                                        

                                        {/* EL ESTADO YA NO SE ELIGE: SE DERIVA DE LAS FECHAS.
                                            Un desplegable de estado ofrecia una decision QUE YA
                                            ESTABA TOMADA — con fecha de alta futura la persona esta
                                            en proceso, lo diga el selector o no—, y por no aplicarlo
                                            alguien creado con fecha 08/10 nacia en «Alta» y con
                                            acceso. Es la misma familia que el interruptor de `activo`
                                            que se quito en Fase 14.

                                            La regla vive en el servidor (`estadoPersona.estadoAlCrear`):
                                              baja ya llegada -> Baja · alta no llegada -> En proceso
                                              resto (pasada, hoy o SIN fecha) -> Alta */}
                                    </DatosBasicosContainer>
                                </PerfilHeader>

                                <AccionesPerfilRow>
                                    <UploadContainer>
                                        <TituloCategoria>Foto de perfil</TituloCategoria>
                                        <Form.Control
                                            type="file"
                                            id='imagenPersona_img'
                                            accept=".jpg,.jpeg,.png,.webp"
                                            max-file-size="3072"
                                            name="imagenPersona_img"
                                            onChange={handleChange}
                                            size="sm"
                                        />
                                    </UploadContainer>
                                </AccionesPerfilRow>
                            </SeccionCard>

                            {/* Sección Contacto */}
                            <SeccionCard>
                                <TituloSeccion>
                                    <Phone size={20} /> Contacto
                                </TituloSeccion>
                                <CampoGrid $columnas={4}>
                                    <Form.Group>
                                        <TituloCategoria>Email corporativo <span>*</span></TituloCategoria>
                                        <Form.Control type='email' name='mail_empresa' value={formData.mail_empresa || ''} onChange={handleChange} />
                                        <ErrorForm mensaje={camposRequeridos.mail_empresa} estadoAlerta={estadoCampoReque.mail_empresa} />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Teléfono móvil</TituloCategoria>
                                        <Form.Control type='text' name='telefono_empresa' value={formData.telefono_empresa || ''} onChange={handleChange} />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Teléfono fijo</TituloCategoria>
                                        <Form.Control type='text' name='telefono_fijo' value={formData.telefono_fijo || ''} onChange={handleChange} />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Extensión</TituloCategoria>
                                        <Form.Control type='text' name='extension_telefono' value={formData.extension_telefono || ''} onChange={handleChange} />
                                    </Form.Group>

                                    {/* LOS PERSONALES, que ya existian en la base desde Fase 12
                                        (`telefono_personal`, `correo_personal`) y en la ficha de editar,
                                        pero no en este formulario. `addPersona` no lleva lista blanca y
                                        los dos modelos los declaran, asi que se guardan sin tocar nada
                                        del servidor. */}
                                    <Form.Group>
                                        <TituloCategoria>Correo personal</TituloCategoria>
                                        <Form.Control type='email' name='correo_personal' value={formData.correo_personal || ''} onChange={handleChange} />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Teléfono personal</TituloCategoria>
                                        <Form.Control type='text' name='telefono_personal' value={formData.telefono_personal || ''} onChange={handleChange} />
                                    </Form.Group>
                                </CampoGrid>
                            </SeccionCard>

                            {/* Sección Ubicación */}
                            <SeccionCard>
                                <TituloSeccion>
                                    <MapPin size={20} /> Ubicación
                                </TituloSeccion>
                                <CampoGrid $columnas={4}>
                                    <Form.Group>
                                        <TituloCategoria>Código Postal</TituloCategoria>
                                        <Form.Control type="number" name="codigo_postal" value={formData.codigo_postal || ''} onChange={handleChange} />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Provincia</TituloCategoria>
                                        <Form.Select value={formData.provincia || ''} name="provincia" onChange={handleChange}>
                                            <option value="">Seleccionar...</option>
                                            {provincias.sort((a, b) => a.localeCompare(b)).map((provincia, index) => (
                                                <option key={index} value={provincia}>{provincia}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Población</TituloCategoria>
                                        <Form.Select value={formData.poblacion || ''} name="poblacion" onChange={handleChange}>
                                            <option value="">Seleccionar...</option>
                                            {municipios.map((poblaciones, index) => (
                                                <option key={index} value={poblaciones.name}>{poblaciones.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Dirección</TituloCategoria>
                                        <Form.Control type='text' name='direccion' value={formData.direccion || ''} onChange={handleChange} />
                                    </Form.Group>
                                </CampoGrid>
                            </SeccionCard>
                        </TabPanel>
                    </Col>
                    <Col>
                        {/* Contenido de la pestaña Datos de Empresa */}
                        <TabPanel value={tabValue} index={1}>
                            <SeccionCard>
                                <TituloSeccion>
                                    <Building2 size={20} /> Información General
                                </TituloSeccion>
                                <CampoGrid $columnas={3}>
                                    <Form.Group>
                                        <TituloCategoria>Oficinas</TituloCategoria>
                                        <Autocomplete
                                            multiple
                                            id="oficinas-select"
                                            options={oficinas}
                                            getOptionLabel={(option) => `${option.nombre} - ${option.poblacion}`}
                                            value={formData.Oficinas || []}
                                            onChange={(event, newValue) => handleChange(event, newValue, 'Oficinas')}
                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder="Selecciona oficinas"
                                                    size="small"
                                                />
                                            )}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => (
                                                    <Chip
                                                        label={option.nombre}
                                                        {...getTagProps({ index })}
                                                        key={option.Id}
                                                        size="small"
                                                    />
                                                ))
                                            }
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '4px 8px',
                                                    minHeight: '38px',
                                                }
                                            }}
                                        />
                                    </Form.Group>

                                    {/* EMPRESA CONTRATANTE Y TIPO DE CONTRATO VIVEN AQUI, no en «Personal».
                                            Los dos describen la RELACION LABORAL —con que razon social
                                            firma y bajo que modalidad—, no a la persona. En «Personal»
                                            estaban al lado del DNI y la fecha de nacimiento. */}
                                        {tipo !== 'colaboradora' && (
                                        <Form.Group>
                                            <TituloCategoria>Empresa contratante <span>*</span></TituloCategoria>
                                            {/* EXPLICITA, NO OBLIGATORIA — y el asterisco se queda.
                                                Un autonomo no tiene razon social contratante porque
                                                no la hay. Pero si se permitiera dejarlo en blanco,
                                                «es autonomo» y «se me olvido» no se distinguirian
                                                nunca mas. Asi que se puede no tener, pero hay que
                                                decirlo: por eso hay una opcion y no un hueco.
                                                El centinela 'sin' es el mismo que ya usa el filtro
                                                del listado (?empresacontratante=sin), y el servidor
                                                lo traduce a NULL — ver services/empresaContratante.
                                                Solo para internos: una colaboradora se contrata a
                                                traves de su empresa colaboradora. */}
                                            <Form.Select
                                                name="empresa_contratante_id"
                                                value={formData.empresa_contratante_id ?? ''}
                                                onChange={(e) => setFormData((prev) => ({
                                                    ...prev,
                                                    /* 'sin' viaja TAL CUAL: convertirlo a null aqui
                                                       lo volveria indistinguible de no haber
                                                       elegido, que es justo lo que se separa. */
                                                    empresa_contratante_id: e.target.value === 'sin'
                                                        ? 'sin'
                                                        : (e.target.value ? Number(e.target.value) : null),
                                                }))}
                                            >
                                                <option value="">Seleccionar...</option>
                                                <option value="sin">Autónomo / sin empresa contratante</option>
                                                {/* `empresasContratantes`, NO `negocios`: es la razon social con la
                                                    que firma, no la marca para la que trabaja — y la columna
                                                    tiene clave ajena a `empresas`. */}
                                                {(empresasContratantes || []).map((emp) => (
                                                    <option key={emp.Id} value={emp.Id}>{emp.razon_social}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                        )}

                                        <Form.Group>
                                            <TituloCategoria>Tipo de contrato</TituloCategoria>
                                            {/* Opcional, y los valores se PIDEN por API: la pantalla
                                                no lleva ninguno escrito. */}
                                            <Form.Select
                                                name="tipo_contrato"
                                                value={formData.tipo_contrato || ''}
                                                onChange={(e) => setFormData((prev) => ({
                                                    ...prev, tipo_contrato: e.target.value || null,
                                                }))}
                                            >
                                                <option value="">Sin asignar</option>
                                                {tiposContrato.map((t) => (
                                                    <option key={t.clave} value={t.clave}>{t.etiqueta}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>

                                        {/* EL ROL YA NO SE PIDE: toda persona nace como «General» y Sistemas lo cambia
                                            despues desde la ficha, que es donde vive esa decision. Es lo
                                            que ya hacia el wizard.

                                            Y el servidor no se fia del formulario: `addPersona` sobrescribe
                                            `rol_id` con el rol por defecto y descarta el `Rol` del cuerpo,
                                            llegue por aqui o por la API — eso se cerro en Fase C. Quitar el
                                            campo no cierra el agujero: deja de ofrecer una eleccion que el
                                            servidor ya ignoraba. */}

                                    <Form.Group>
                                        <TituloCategoria>Fecha de Alta</TituloCategoria>
                                        <Form.Control type="date" name="fecha_alta" value={formData.fecha_alta || ''} onChange={handleChange} />
                                        <small style={{ color: '#6c757d', display: 'block', marginTop: '4px' }}>
                                            Si es futura, la persona nace <strong>En proceso</strong> y sin acceso.
                                            Vacía o pasada, nace en <strong>Alta</strong>.
                                        </small>
                                    </Form.Group>
                                    {/* SOLO PARA REGISTRAR A ALGUIEN QUE YA SE FUE.
                                        Sin este campo, dar de alta a una persona historica obligaba a
                                        crearla en «Alta» —con acceso— y editarla despues: un rato con
                                        acceso para quien nunca debio tenerlo. Con la fecha, nace en Baja
                                        directamente. No es una decision: es un hecho. */}
                                    <Form.Group>
                                        <TituloCategoria>Fecha de Baja</TituloCategoria>
                                        <Form.Control type="date" name="fecha_baja" value={formData.fecha_baja || ''} onChange={handleChange} />
                                        <small style={{ color: '#6c757d', display: 'block', marginTop: '4px' }}>
                                            Sólo si esta persona <strong>ya no está</strong>: nace en Baja y sin acceso.
                                            Déjala vacía en un alta normal.
                                        </small>
                                    </Form.Group>
                                </CampoGrid>
                            </SeccionCard>

                            {/* Sección de Cargos Internos (empleado) / Empresa (colaboradora) */}
                            <SeccionCard>
                                <SeccionHeader>
                                    <TituloSeccion style={{ margin: 0, border: 'none', paddingBottom: 0 }}>
                                        <Briefcase size={20} /> {tipo === "colaboradora"
                                            ? (filasInternos.length <= 1 ? 'Empresa' : 'Empresas')
                                            : (filasInternos.length <= 1 ? 'Cargo Interno' : 'Cargos Internos')}
                                    </TituloSeccion>
                                    <AddButton
                                        bonificados="true"
                                        as="button"
                                        primario="true"
                                        onClick={agregarFilaInterno}
                                        form="true"
                                        type="button"
                                    >
                                        + Añadir
                                    </AddButton>
                                </SeccionHeader>

                                {filasInternos.length === 0 ? (
                                    <EmptyState>
                                        <p>{tipo === "colaboradora" ? 'No hay empresas asignadas.' : 'No hay cargos internos asignados.'} Pulse "Añadir" para agregar uno.</p>
                                    </EmptyState>
                                ) : (
                                    filasInternos.map((fila, index) => {
                                        const tieneError = erroresCargos.internos.includes(index);

                                        return (
                                            <CargoCard key={index} $error={tieneError}>
                                                {tipo === "colaboradora" ? (
                                                    <div style={{ display: 'flex', gap: '16px', alignItems: 'end' }}>
                                                        <Form.Group style={{ flex: 1 }}>
                                                            <TituloCategoria>Empresa Colaboradora <span>*</span></TituloCategoria>
                                                            <Form.Select
                                                                value={fila.empresa}
                                                                onChange={(e) => handleChangeFilaInterno(index, 'empresa', e.target.value)}
                                                                style={tieneError && !fila.empresa ? {borderColor: '#dc3545'} : {}}
                                                            >
                                                                <option value="">Seleccionar...</option>
                                                                {empresasColaboradoras?.map((ec) => (
                                                                    <option key={ec.Id} value={ec.Id}>{ec.nombre}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                        <BotonEliminar onClick={() => eliminarFilaInterno(index)}>
                                                            <Trash2 size={18} />
                                                        </BotonEliminar>
                                                    </div>
                                                ) : (
                                                    <CargoGrid>
                                                        <Form.Group>
                                                            <TituloCategoria>Negocio <span>*</span></TituloCategoria>
                                                            <Form.Select
                                                                value={fila.empresa}
                                                                onChange={(e) => handleChangeFilaInterno(index, 'empresa', e.target.value)}
                                                                style={tieneError && !fila.empresa ? {borderColor: '#dc3545'} : {}}
                                                            >
                                                                <option value="">Seleccionar...</option>
                                                                {negocios?.map((empresa) => (
                                                                    <option key={empresa.Id} value={empresa.Id}>{empresa.nombre}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>

                                                        <Form.Group>
                                                            <TituloCategoria>Departamento <span>*</span></TituloCategoria>
                                                            <Form.Select
                                                                value={fila.departamento || ''}
                                                                onChange={(e) => handleChangeFilaInterno(index, 'departamento', e.target.value)}
                                                                disabled={!fila.empresa}
                                                                style={tieneError && !fila.departamento ? {borderColor: '#dc3545'} : {}}
                                                            >
                                                                <option value="">Seleccionar...</option>
                                                                {getDepartamentosPorEmpresaYTipo(fila.empresa, index, 'interno', filasInternos).map((departamento) => (
                                                                    <option key={departamento.Id} value={departamento.Id}>{departamento.nombre}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>

                                                        <Form.Group>
                                                            <TituloCategoria>Cargo <span>*</span></TituloCategoria>
                                                            <Form.Control
                                                                type="text"
                                                                value={fila.cargo || ''}
                                                                disabled={!fila.empresa || !fila.departamento}
                                                                onChange={(e) => handleChangeFilaInterno(index, 'cargo', e.target.value)}
                                                                style={tieneError && !fila.cargo ? {borderColor: '#dc3545'} : {}}
                                                            />
                                                        </Form.Group>

                                                        <BotonEliminar onClick={() => eliminarFilaInterno(index)}>
                                                            <Trash2 size={18} />
                                                        </BotonEliminar>
                                                    </CargoGrid>
                                                )}
                                                {tieneError && (
                                                    <small style={{ color: '#dc3545', marginTop: '8px', display: 'block' }}>
                                                        {tipo === "colaboradora" ? 'Seleccione una empresa.' : 'Esta empresa necesita departamento y cargo.'}
                                                    </small>
                                                )}
                                            </CargoCard>
                                        );
                                    })
                                )}
                            </SeccionCard>

                            {/* Sección de Cargos Organigrama - solo empleados */}
                            {tipo !== "colaboradora" && (
                            <SeccionCard>
                                <SeccionHeader>
                                    <TituloSeccion style={{ margin: 0, border: 'none', paddingBottom: 0 }}>
                                        <Users size={20} /> {filasOrganigrama.length <= 1 ? 'Cargo Organigrama' : 'Cargos Organigrama'}
                                    </TituloSeccion>
                                    <AddButton
                                        bonificados="true"
                                        as="button"
                                        primario="true"
                                        onClick={agregarFilaOrganigrama}
                                        form="true"
                                        type="button"
                                    >
                                        + Añadir
                                    </AddButton>
                                </SeccionHeader>

                                {filasOrganigrama.length === 0 ? (
                                    <EmptyState>
                                        <p>No hay cargos de organigrama asignados. Pulse "Añadir" para agregar uno.</p>
                                    </EmptyState>
                                ) : (
                                    filasOrganigrama.map((fila, index) => {
                                        const tieneError = erroresCargos.organigrama.includes(index);
                                        const esIntermedio = esMandoIntermedio(fila.departamento, fila.empresa);

                                        return (
                                            <CargoCard key={index} $error={tieneError}>
                                                <CargoGrid $organigrama>
                                                    <Form.Group>
                                                        <TituloCategoria>Negocio <span>*</span></TituloCategoria>
                                                        <Form.Select
                                                            value={fila.empresa}
                                                            onChange={(e) => handleChangeFilaOrganigrama(index, 'empresa', e.target.value)}
                                                            style={tieneError && !fila.empresa ? {borderColor: '#dc3545'} : {}}
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {negocios?.map((empresa) => (
                                                                <option key={empresa.Id} value={empresa.Id}>{empresa.nombre}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group>
                                                        <TituloCategoria>Departamento <span>*</span></TituloCategoria>
                                                        <Form.Select
                                                            value={fila.departamento}
                                                            onChange={(e) => handleChangeFilaOrganigrama(index, 'departamento', e.target.value)}
                                                            disabled={!fila.empresa}
                                                            style={tieneError && !fila.departamento ? {borderColor: '#dc3545'} : {}}
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {getDepartamentosPorEmpresaYTipo(fila.empresa, index, 'organigrama', filasOrganigrama).map((departamento) => (
                                                                <option key={departamento.Id} value={departamento.Id}>{departamento.nombre}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group>
                                                        <TituloCategoria>Cargo <span>*</span></TituloCategoria>
                                                        <Form.Control
                                                            type="text"
                                                            value={!fila.departamento ? '' : fila.cargo}
                                                            disabled={!fila.empresa || !fila.departamento}
                                                            onChange={(e) => handleChangeFilaOrganigrama(index, 'cargo', e.target.value)}
                                                            style={tieneError && !fila.cargo ? {borderColor: '#dc3545'} : {}}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group>
                                                        <TituloCategoria>Adjunto</TituloCategoria>
                                                        <Form.Select
                                                            value={esIntermedio ? '' : fila.adjunto}
                                                            onChange={(e) => handleChangeFilaOrganigrama(index, 'adjunto', e.target.value)}
                                                            disabled={!fila.empresa || esIntermedio}
                                                        >
                                                            <option value="">{esIntermedio ? 'Mando intermedio' : 'Seleccionar...'}</option>
                                                            {Array.isArray(adjuntosPorCargo[index]) && adjuntosPorCargo[index].map((adjunto) => (
                                                                <option key={adjunto.id} value={adjunto.id}>
                                                                    {adjunto.nombre} {adjunto.apellidos}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group style={{ textAlign: 'center' }}>
                                                        <TituloCategoria>Responsable</TituloCategoria>
                                                        <Switch
                                                            checked={esIntermedio ? false : Boolean(fila.responsable)}
                                                            name="responsable"
                                                            disabled={esIntermedio}
                                                            onChange={e => handleChangeFilaOrganigrama(index, 'responsable', e.target.checked)}
                                                            sx={{
                                                                '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' },
                                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' },
                                                                '& .MuiSwitch-switchBase:not(.Mui-checked)': { color: '#f44336' },
                                                                '& .MuiSwitch-switchBase:not(.Mui-checked) + .MuiSwitch-track': { backgroundColor: '#f44336' },
                                                            }}
                                                        />
                                                    </Form.Group>

                                                    <BotonEliminar onClick={() => eliminarFilaOrganigrama(index)}>
                                                        <Trash2 size={18} />
                                                    </BotonEliminar>
                                                </CargoGrid>
                                                {tieneError && (
                                                    <small style={{ color: '#dc3545', marginTop: '8px', display: 'block' }}>
                                                        Este Negocio necesita departamento y cargo.
                                                    </small>
                                                )}
                                            </CargoCard>
                                        );
                                    })
                                )}
                            </SeccionCard>
                            )}
                        </TabPanel>

                        {/* Contenido de la pestaña Vacaciones */}
                        <TabPanel value={tabValue} index={2}>
                            <SeccionCard>
                                <TituloSeccion>
                                    <Calendar size={20} /> Configuración de Vacaciones
                                </TituloSeccion>
                                <VacacionesGrid>
                                    <Form.Group>
                                        <TituloCategoria>Calendario Laboral</TituloCategoria>
                                        <Form.Select
                                            value={tipo === "colaboradora" ? (formData.calendario_laboral_colab_id || '') : (formData.calendario_laboral_id || '')}
                                            name={tipo === "colaboradora" ? "calendario_laboral_colab_id" : "calendario_laboral_id"}
                                            onChange={(e) => {
                                                const calId = e.target.value;
                                                const lista = tipo === "colaboradora" ? calendariosLaboralesColab : calendariosLaborales;
                                                const campo = tipo === "colaboradora" ? 'calendario_laboral_colab_id' : 'calendario_laboral_id';
                                                const calSel = lista.find(c => c.Id.toString() === calId);
                                                if (calSel) {
                                                    const diasVacacionesTotales = (calSel.dias_vacaciones_verano || 0) + (calSel.dias_vacaciones_normal || 0);
                                                    const diasVeranoObligatorios = calSel.dias_vacaciones_verano || 0;
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        [campo]: calId,
                                                        dias_vacaciones_totales: diasVacacionesTotales,
                                                        dias_verano_obligatorios: diasVeranoObligatorios
                                                    }));
                                                } else {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        [campo]: calId
                                                    }));
                                                }
                                            }}
                                        >
                                            <option value="">{tipo === "colaboradora" ? "Seleccionar calendario colaborador" : "Seleccionar calendario laboral"}</option>
                                            {(tipo === "colaboradora" ? calendariosLaboralesColab : calendariosLaborales).map((cal) => (
                                                <option key={cal.Id} value={cal.Id}>
                                                    {cal.nombre} - {cal.provincia} ({cal.anio})
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    {/* Supervisores: OCULTO para personas colaboradoras. El alta tambien descarta
                                        supervisor_ids en servidor (PersonaColaboradora_Controller.js:150) y
                                        persona_supervisores tiene las dos FK a personas.Id. Si solo se tapara la
                                        edicion, el alta seguiria prometiendo lo mismo. */}
                                    {tipo !== "colaboradora" && (
                                    <Form.Group>
                                        <TituloCategoria>Supervisores</TituloCategoria>
                                        <Autocomplete
                                            multiple
                                            id="supervisor-select"
                                            size="small"
                                            options={supervisores}
                                            getOptionLabel={(option) => `${option.nombre} ${option.apellidos}`}
                                            value={supervisores.filter(s => (formData.supervisor_ids || []).includes(s.Id))}
                                            onChange={(event, newValue) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    supervisor_ids: newValue.map(v => v.Id)
                                                }));
                                            }}
                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder={formData.supervisor_ids?.length ? '' : 'Selecciona supervisores'}
                                                />
                                            )}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '4px 8px',
                                                    minHeight: '38px',
                                                    height: 'auto',
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '2px 0 !important',
                                                }
                                            }}
                                        />
                                    </Form.Group>
                                    )}
                                </VacacionesGrid>

                                {/* Información del calendario seleccionado */}
                                {(formData.calendario_laboral_id || formData.calendario_laboral_colab_id) && (() => {
                                    const calSel = tipo === "colaboradora"
                                        ? calendariosLaboralesColab.find(c => c.Id.toString() === formData.calendario_laboral_colab_id?.toString())
                                        : calendariosLaborales.find(c => c.Id.toString() === formData.calendario_laboral_id?.toString());
                                    if (calSel) {
                                        return (
                                            <InfoCalendario>
                                                <small>
                                                    <strong>Calendario:</strong> {calSel.nombre} |
                                                    <strong> Vac. Verano:</strong> {calSel.dias_vacaciones_verano || 0} días |
                                                    <strong> Vac. Normal:</strong> {calSel.dias_vacaciones_normal || 0} días |
                                                    <strong> Horario:</strong> L-J {parseFloat(calSel.horas_lunes_jueves)}h, V {parseFloat(calSel.horas_viernes)}h
                                                </small>
                                            </InfoCalendario>
                                        );
                                    }
                                    return null;
                                })()}
                            </SeccionCard>

                            <SeccionCard>
                                <TituloSeccion>
                                    <Umbrella size={20} /> Días de Vacaciones
                                </TituloSeccion>
                                <VacacionesGrid>
                                    <Form.Group>
                                        <TituloCategoria>Días Totales</TituloCategoria>
                                        <Form.Control
                                            type='number'
                                            name='dias_vacaciones_totales'
                                            min="0"
                                            value={formData.dias_vacaciones_totales ?? 22}
                                            disabled
                                            style={{ backgroundColor: '#f5f5f5' }}
                                        />
                                    </Form.Group>

                                    <Form.Group>
                                        <TituloCategoria>Obligatorios Verano</TituloCategoria>
                                        <Form.Control
                                            type='number'
                                            name='dias_verano_obligatorios'
                                            min="0"
                                            value={formData.dias_verano_obligatorios ?? 10}
                                            disabled
                                            style={{ backgroundColor: '#f5f5f5' }}
                                        />
                                    </Form.Group>
                                </VacacionesGrid>
                                <small style={{ color: '#6c757d', display: 'block', marginTop: '-10px' }}>
                                    Los valores se definen automáticamente según el calendario laboral seleccionado
                                </small>

                                <Form.Group style={{ marginTop: '20px' }}>
                                    <TituloCategoria>Observaciones</TituloCategoria>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        name="observaciones_vacaciones"
                                        value={formData.observaciones_vacaciones || ''}
                                        onChange={(e) => setFormData(prev => ({
                                            ...prev,
                                            observaciones_vacaciones: e.target.value
                                        }))}
                                        placeholder="Cualquier información relevante sobre las vacaciones..."
                                    />
                                </Form.Group>
                            </SeccionCard>
                        </TabPanel>
                    </Col>

                    <Col>
                        {/* Contenido de la pestaña Soporte */}
                        {persona.persona?.rol?.toLowerCase() === 'super administrador' && (
                            <TabPanel value={tabValue} index={3}>
                                {/* Sección Credenciales */}
                                <SeccionCard>
                                    <TituloSeccion>
                                        <Lock size={20} /> Credenciales
                                    </TituloSeccion>
                                    <VacacionesGrid>
                                        <Form.Group>
                                            <TituloCategoria>Usuario NAS</TituloCategoria>
                                            <Form.Control type='text' name='usuario_nas' value={formData.usuario_nas || ''} onChange={handleChange} />
                                        </Form.Group>
                                        <Form.Group>
                                            <TituloCategoria>Contraseña NAS</TituloCategoria>
                                            <Form.Control type='text' name='password_nas' value={formData.password_nas || ''} onChange={handleChange} />
                                        </Form.Group>
                                    </VacacionesGrid>
                                    <VacacionesGrid>
                                        <Form.Group>
                                            <TituloCategoria>Email Microsoft 365</TituloCategoria>
                                            <Form.Control type='email' name='mail_empresa' value={formData.mail_empresa || ''} onChange={handleChange} />
                                        </Form.Group>
                                        <Form.Group>
                                            <TituloCategoria>Contraseña Microsoft 365</TituloCategoria>
                                            <Form.Control type='text' name='password_m365' value={formData.password_m365 || ''} onChange={handleChange} />
                                        </Form.Group>
                                    </VacacionesGrid>
                                </SeccionCard>

                                {/* Sección Conexión Remota */}
                                <SeccionCard>
                                    <TituloSeccion>
                                        <Monitor size={20} /> Conexión Remota
                                    </TituloSeccion>
                                    <SoporteGrid>
                                        <ConexionRemotaContainer>
                                            <Form.Group>
                                                <TituloCategoria>AnyDesk - PC</TituloCategoria>
                                                <Form.Control type='text' name='conexion_remota' value={formData.conexion_remota || ''} onChange={handleChange} />
                                            </Form.Group>

                                            <Form.Group>
                                                <TituloCategoria>RuskDesk - PC</TituloCategoria>
                                                <Form.Control type='text' maxLength={9} name='ruskdesk_pc' value={formData.ruskdesk_pc || ''} onChange={handleChange} />
                                            </Form.Group>

                                        </ConexionRemotaContainer>

                                        <ConexionRemotaContainer>

                                            <Form.Group>
                                                <TituloCategoria>AnyDesk - Móvil</TituloCategoria>
                                                <Form.Control type='text' name='conexion_remota_movil' value={formData.conexion_remota_movil || ''} onChange={handleChange} />
                                            </Form.Group>

                                            <Form.Group>
                                                <TituloCategoria>RuskDesk - Móvil</TituloCategoria>
                                                <Form.Control type='text' maxLength={9} name='ruskdesk_movil' value={formData.ruskdesk_movil || ''} onChange={handleChange} />
                                            </Form.Group>

                                        </ConexionRemotaContainer>

                                        <Form.Group>
                                            <TituloCategoria>Contraseña AnyDesk</TituloCategoria>
                                            <Form.Control type='text' name='password_anydesk' value={formData.password_anydesk || ''} onChange={handleChange} />
                                        </Form.Group>
                                    </SoporteGrid>
                                </SeccionCard>

                                {/* Sección Equipo */}
                                <SeccionCard>
                                    <TituloSeccion>
                                        <Laptop size={20} /> Equipo
                                    </TituloSeccion>
                                    <VacacionesGrid>
                                        <Form.Group>
                                            <TituloCategoria>Contraseña Administrador</TituloCategoria>
                                            <Form.Control type='text' name='password_admin_equipo' value={formData.password_admin_equipo || ''} onChange={handleChange} />
                                        </Form.Group>
                                        <Form.Group>
                                            <TituloCategoria>Contraseña Usuario</TituloCategoria>
                                            <Form.Control type='text' name='password_usuario_equipo' value={formData.password_usuario_equipo || ''} onChange={handleChange} />
                                        </Form.Group>
                                    </VacacionesGrid>

                                    <Form.Group>
                                        <TituloCategoria>BitLocker</TituloCategoria>
                                        <Form.Control type='text' maxLength={55} name='bit_locker' value={formData.bit_locker || ''} onChange={handleChange} />
                                    </Form.Group>
                                    <ErrorForm mensaje={camposRequeridos.bit_locker} estadoAlerta={estadoCampoReque.bit_locker} />
                                </SeccionCard>

                                {/* Sección Observaciones */}
                                <SeccionCard>
                                    <TituloSeccion>
                                        <Server size={20} /> Observaciones de Soporte
                                    </TituloSeccion>
                                    <Form.Group>
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            name="observaciones_soporte"
                                            value={formData.observaciones_soporte || ''}
                                            onChange={handleChange}
                                            placeholder="Notas técnicas, configuraciones especiales, etc."
                                            style={{ resize: 'vertical' }}
                                        />
                                    </Form.Group>
                                    <ErrorForm mensaje={camposRequeridos.observaciones_soporte} estadoAlerta={estadoCampoReque.observaciones_soporte} />
                                </SeccionCard>

                                {/* Sección Gestionar Vacaciones — OCULTA en Fase 4.2: el ámbito se concede desde
                                    /configuracion/permisos → "Ámbito por empresa". Flag en config/flags.js; no se
                                    borra hasta Fase 6 (evita dos escritores de gestion_vacaciones_*). */}
                                {!OCULTAR_GESTION_VACACIONES_FICHA && tipo !== "colaboradora" && <SeccionCard>
                                    <TituloSeccion>
                                        <Umbrella size={20} /> Gestionar Vacaciones
                                    </TituloSeccion>
                                    <VacacionesGrid>
                                        <Form.Group>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={formData.gestion_vacaciones_int !== null && formData.gestion_vacaciones_int !== undefined}
                                                        onChange={(e) => {
                                                            if (!e.target.checked) {
                                                                setFormData(prev => ({ ...prev, gestion_vacaciones_int: null }));
                                                            } else {
                                                                setFormData(prev => ({ ...prev, gestion_vacaciones_int: '{}' }));
                                                            }
                                                        }}
                                                        sx={{ color: '#6c757d', '&.Mui-checked': { color: 'rgba(0, 60, 102, 0.9)' } }}
                                                    />
                                                }
                                                label={<span style={{ fontSize: '14px', fontWeight: 600, color: '#495057' }}>Gestionar vacaciones internas</span>}
                                            />
                                            {formData.gestion_vacaciones_int !== null && formData.gestion_vacaciones_int !== undefined && (() => {
                                                let parsed = {};
                                                try { parsed = JSON.parse(formData.gestion_vacaciones_int || '{}'); } catch {}
                                                if (Array.isArray(parsed)) parsed = {};
                                                /* `parsed.empresas` NO se renombra: es una clave del FORMATO
                                                       ANTIGUO guardado en `gestion_vacaciones_int`, y este bloque
                                                       existe para migrarlo. Cambiar la lectura dejaria sin migrar
                                                       los valores ya guardados, en silencio. */
                                                    if (parsed.empresas) {
                                                    const migrated = {};
                                                    (parsed.empresas || []).forEach(eId => { migrated[eId] = []; });
                                                    (parsed.departamentos || []).forEach(dId => {
                                                        const dept = departamentos.find(d => d.Id === dId);
                                                        if (dept && dept.Negocios) {
                                                            dept.Negocios.forEach(emp => {
                                                                if (migrated[emp.Id] && !migrated[emp.Id].includes(dId)) migrated[emp.Id].push(dId);
                                                            });
                                                        }
                                                    });
                                                    parsed = migrated;
                                                }
                                                const empIds = Object.keys(parsed).map(Number);
                                                return (
                                                <>
                                                    <Autocomplete
                                                        multiple
                                                        id="gestion-vac-int-empresas"
                                                        options={negocios || []}
                                                        getOptionLabel={(option) => option.nombre || ''}
                                                        value={negocios.filter(e => empIds.includes(e.Id))}
                                                        onChange={(event, newValue) => {
                                                            const nuevoObj = {};
                                                            newValue.forEach(emp => {
                                                                nuevoObj[emp.Id] = parsed[emp.Id] || [];
                                                            });
                                                            setFormData(prev => ({ ...prev, gestion_vacaciones_int: JSON.stringify(nuevoObj) }));
                                                        }}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder="Selecciona Negocios"
                                                                size="small"
                                                            />
                                                        )}
                                                        renderTags={(value, getTagProps) =>
                                                            value.map((option, index) => (
                                                                <Chip
                                                                    label={option.nombre}
                                                                    {...getTagProps({ index })}
                                                                    key={option.Id}
                                                                    size="small"
                                                                />
                                                            ))
                                                        }
                                                        sx={{
                                                            mt: 1,
                                                            width: '100%',
                                                            '& .MuiOutlinedInput-root': {
                                                                padding: '4px 8px',
                                                                minHeight: '38px',
                                                            }
                                                        }}
                                                    />
                                                    {empIds.length > 0 && empIds.map(empId => {
                                                        const emp = negocios.find(e => e.Id === empId);
                                                        if (!emp) return null;
                                                        const deptIdsEmp = parsed[empId] || [];
                                                        const deptOptions = departamentos.filter(d =>
                                                            d.Negocios && d.Negocios.some(e => e.Id === empId)
                                                        );
                                                        return (
                                                            <div key={empId} style={{ marginTop: '8px', padding: '8px 0px 8px 12px', backgroundColor: '#f8f9fa', borderRadius: '6px', borderLeft: '3px solid rgba(0, 60, 102, 0.6)' }}>
                                                                <small style={{ fontWeight: 600, color: '#495057', display: 'block', marginBottom: '4px' }}>{emp.nombre}</small>
                                                                <Autocomplete
                                                                    multiple
                                                                    id={`gestion-vac-int-deptos-${empId}`}
                                                                    options={deptOptions}
                                                                    getOptionLabel={(option) => option.nombre || ''}
                                                                    value={departamentos.filter(d => deptIdsEmp.includes(d.Id))}
                                                                    onChange={(event, newValue) => {
                                                                        const ids = newValue.map(v => v.Id);
                                                                        const nuevoObj = { ...parsed, [empId]: ids };
                                                                        setFormData(prev => ({ ...prev, gestion_vacaciones_int: JSON.stringify(nuevoObj) }));
                                                                    }}
                                                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            variant="outlined"
                                                                            placeholder="Selecciona departamentos"
                                                                            size="small"
                                                                        />
                                                                    )}
                                                                    renderTags={(value, getTagProps) =>
                                                                        value.map((option, index) => (
                                                                            <Chip
                                                                                label={option.nombre}
                                                                                {...getTagProps({ index })}
                                                                                key={option.Id}
                                                                                size="small"
                                                                            />
                                                                        ))
                                                                    }
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            padding: '4px 8px',
                                                                            minHeight: '38px',
                                                                            backgroundColor: '#fff',
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </>
                                                );
                                            })()}
                                        </Form.Group>

                                        <Form.Group>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={formData.gestion_vacaciones_colab !== null && formData.gestion_vacaciones_colab !== undefined}
                                                        onChange={(e) => {
                                                            if (!e.target.checked) {
                                                                setFormData(prev => ({ ...prev, gestion_vacaciones_colab: null }));
                                                            } else {
                                                                setFormData(prev => ({ ...prev, gestion_vacaciones_colab: '[]' }));
                                                            }
                                                        }}
                                                        sx={{ color: '#6c757d', '&.Mui-checked': { color: 'rgba(0, 60, 102, 0.9)' } }}
                                                    />
                                                }
                                                label={<span style={{ fontSize: '14px', fontWeight: 600, color: '#495057' }}>Gestionar vacaciones colaboradores</span>}
                                            />
                                            {formData.gestion_vacaciones_colab !== null && formData.gestion_vacaciones_colab !== undefined && (
                                                <Autocomplete
                                                    multiple
                                                    id="gestion-vac-colab-select"
                                                    options={(empresasColaboradoras || []).filter(e => e.vacaciones)}
                                                    getOptionLabel={(option) => option.nombre || ''}
                                                    value={(empresasColaboradoras || []).filter(e => {
                                                        try {
                                                            const ids = JSON.parse(formData.gestion_vacaciones_colab || '[]');
                                                            return ids.includes(e.Id);
                                                        } catch { return false; }
                                                    })}
                                                    onChange={(event, newValue) => {
                                                        const ids = newValue.map(v => v.Id);
                                                        setFormData(prev => ({ ...prev, gestion_vacaciones_colab: JSON.stringify(ids) }));
                                                    }}
                                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Selecciona empresas colaboradoras"
                                                            size="small"
                                                        />
                                                    )}
                                                    renderTags={(value, getTagProps) =>
                                                        value.map((option, index) => (
                                                            <Chip
                                                                label={option.nombre}
                                                                {...getTagProps({ index })}
                                                                key={option.Id}
                                                                size="small"
                                                            />
                                                        ))
                                                    }
                                                    sx={{
                                                        mt: 1,
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '4px 8px',
                                                            minHeight: '38px',
                                                        }
                                                    }}
                                                />
                                            )}
                                        </Form.Group>
                                    </VacacionesGrid>
                                </SeccionCard>}

                                {/* Sección Dirección de Envío */}
                                <SeccionCard>
                                    <TituloSeccion>
                                        <Send size={20} /> Dirección de Envío
                                    </TituloSeccion>
                                    <VacacionesGrid>
                                        <Form.Group>
                                            <TituloCategoria>Tipo de Dirección</TituloCategoria>
                                            <Form.Select
                                                name="tipo_direccion_envio"
                                                value={
                                                    formData.direccion_envio === 'personal' ? 'personal' :
                                                    formData.direccion_envio?.startsWith('oficina-') ? formData.direccion_envio :
                                                    'personalizado'
                                                }
                                                onChange={(e) => {
                                                    const valor = e.target.value;
                                                    if (valor === 'personalizado') {
                                                        setFormData(prev => ({ ...prev, direccion_envio: '' }));
                                                    } else {
                                                        setFormData(prev => ({ ...prev, direccion_envio: valor }));
                                                    }
                                                }}
                                            >
                                                <option value="personal">Dirección personal</option>
                                                {formData.Oficinas && formData.Oficinas.map((oficina) => (
                                                    <option key={oficina.Id} value={`oficina-${oficina.Id}`}>
                                                        {oficina.nombre}
                                                    </option>
                                                ))}
                                                <option value="personalizado">Personalizado</option>
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group>
                                            <TituloCategoria>Dirección</TituloCategoria>
                                            {formData.direccion_envio !== 'personal' && !formData.direccion_envio?.startsWith('oficina-') ? (
                                                <Form.Control
                                                    type="text"
                                                    name="direccion_envio"
                                                    placeholder="Introduce la dirección personalizada"
                                                    value={formData.direccion_envio || ''}
                                                    onChange={handleChange}
                                                />
                                            ) : (
                                                <Form.Control
                                                    type="text"
                                                    readOnly
                                                    value={
                                                        formData.direccion_envio === 'personal'
                                                            ? (formData.direccion
                                                                ? [formData.direccion, formData.codigo_postal, formData.poblacion, formData.provincia ? `(${formData.provincia})` : ''].filter(Boolean).join(', ')
                                                                : 'No definida')
                                                            : formData.direccion_envio?.startsWith('oficina-')
                                                                ? (() => {
                                                                    const oficinaId = parseInt(formData.direccion_envio.split('-')[1]);
                                                                    const oficina = formData.Oficinas?.find(o => o.Id === oficinaId);
                                                                    return oficina
                                                                        ? [oficina.direccion, oficina.cp, oficina.poblacion].filter(Boolean).join(', ') || 'No definida'
                                                                        : 'Oficina no encontrada';
                                                                })()
                                                                : 'No definida'
                                                    }
                                                    style={{ backgroundColor: '#f8f9fa' }}
                                                />
                                            )}
                                        </Form.Group>
                                    </VacacionesGrid>
                                </SeccionCard>
                            </TabPanel>
                        )}
                    </Col>
                    <Row>                   
                        <ContenedorBotones>
                            <Boton
                                bonificados="true"
                                grande="true"
                                as="button"
                                primario="true"
                                type="submit"
                                onClick={handleSubmit}
                                form="true"
                            >
                                {tipo === "colaboradora" ? "Agregar Colaborador" : "Agregar Empleado"}
                            </Boton>
                            <Boton
                                grande="true"
                                to={`/gestionpersonas/personas${location.search}`}
                            >
                                Cancelar
                            </Boton>
                        </ContenedorBotones>
                    </Row>
                </Container>
            </Form>
            <DatosCorrectosPersona envioActivado={formCompletado} queryParams={destinoListado} />
            <DatosIncorrectos envioActivado={formCompletado} duplicado={errorEnviarForm.personaDuplicada} />
            <ServerNoCreoPersona envioActivado={errorEnviarForm.personaDuplicada} />
        </>
     );
}

const CabeceraForm = styled.div`
    margin: 2% 0% 0% 35%;
`

const ContenedorBotones = styled.div`
    display: flex;
    gap: 15px;
    justify-content: center;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
`

const TituloCategoria = styled(Form.Label)`
    font-weight: 600;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    line-height: 1.6;
    color: #495057;
    margin-bottom: 6px;
    display: block;

    span {
        color: #dc3545;
        font-weight: 400;
        margin-left: 2px;
    }
`

const TituloSeccion = styled.h4`
    font-weight: 700;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    margin: 0 0 20px 0;
    color: rgba(0, 60, 102, 0.9);
    border-bottom: 2px solid rgba(0, 60, 102, 0.3);
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;

    svg {
        opacity: 0.8;
    }
`

const ContenedorEncabezado = styled.div`
    width: 100%;
    height: 240px;
    border: 3px solid rgba(0, 60, 102, 0.8);
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
`

const SeccionCard = styled.div`
    background: ${props => props.$destacado ? 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' : '#ffffff'};
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
`

const PerfilHeader = styled.div`
    display: flex;
    gap: 30px;
    align-items: flex-start;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }
`

const ImagenPerfilContainer = styled.div`
    flex-shrink: 0;
    text-align: center;
    width: 240px;
`

const ImagenPerfil = styled.img`
    width: 100%;
    height: 240px;
    object-fit: cover;
    border: 3px solid rgba(0, 60, 102, 0.8);
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`

const DatosBasicosContainer = styled.div`
    flex: 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
    }
`

const CampoGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(${props => props.$columnas || 4}, 1fr);
    gap: 20px;
    margin-bottom: 20px;

    @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
    }
`

const VacacionesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`

const SoporteGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 24px;

    @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
    }
`

const InfoCalendario = styled.div`
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
    padding: 16px 20px;
    border-radius: 10px;
    margin-bottom: 24px;
    border: 1px solid #81c784;

    small {
        color: #2e7d32;
        font-size: 13px;
        line-height: 1.6;
    }

    strong {
        font-weight: 600;
    }
`

const AccionesPerfilRow = styled.div`
    position: relative;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e9ecef;
    min-height: 100px;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
`

const UploadContainer = styled.div`
    position: absolute;
    left: 0;
    top: 20px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 2px dashed #dee2e6;
    transition: all 0.2s ease;
    width: 240px;

    &:hover {
        border-color: rgba(0, 60, 102, 0.5);
        background: #f0f4f8;
    }

    input[type="file"] {
        margin-top: 8px;
    }

    @media (max-width: 768px) {
        position: static;
        width: 100%;
    }
`

const CargoCard = styled.div`
    background: ${props => props.$error ? '#fff5f5' : '#fafbfc'};
    border: ${props => props.$error ? '2px solid #dc3545' : '1px solid #e1e4e8'};
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 16px;
    transition: all 0.2s ease;

    &:hover {
        background: ${props => props.$error ? '#fff5f5' : '#f6f8fa'};
        border-color: ${props => props.$error ? '#dc3545' : 'rgba(0, 60, 102, 0.3)'};
    }

    @media (max-width: 576px) {
        padding: 12px 10px;
        margin-bottom: 12px;
    }
`

const CargoGrid = styled.div`
    display: grid;
    grid-template-columns: ${props => props.$organigrama ? '1fr 1fr 1fr 1fr auto auto' : '1fr 1fr 1fr auto'};
    gap: 16px;
    align-items: end;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
        gap: 10px;
    }
`

const BotonEliminar = styled(Button)`
    background-color: #dc3545 !important;
    border: none !important;
    width: 46px;
    height: 46px;
    border-radius: 8px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease !important;

    &:hover {
        background-color: #c82333 !important;
        transform: scale(1.05);
    }
`

const EmptyState = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #6c757d;
    background: #f8f9fa;
    border-radius: 10px;
    border: 2px dashed #dee2e6;

    p {
        margin: 0;
        font-size: 14px;
    }
`

const AddButton = styled(Boton)`
    font-size: 14px !important;
    padding: 10px 20px !important;
    margin: 0 !important;
    display: inline-flex !important;
    align-items: center;
    gap: 8px;
`

const SeccionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid rgba(0, 60, 102, 0.2);
`

const ConexionRemotaContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

export default FormCrearPersona;